export const ROLES_PERMISSIONS = [
  {
    roleName: 'ORG_ADMIN',
    isAdmin:true,
    locations: [
      {
        locationId: 'e45ea2f0-45e0-41df-9158-495bb6f37074',
        locationName:"Andreas Hospital , Zurich.",
        departmentIds: ['ddf8c9a4-ea91-4a4b-960f-41097c556e1b'],
        active: true,
        features: [
          'PLANNING_SHEET_READ',
          'PLANNING_SHEET_WRITE',
          'DUTY_MANAGEMENT_WRITE',
          'DUTY_MANAGEMENT_READ',
          'DUTY_PLANNING_ACTIVATION_WRITE',
          'DUTY_DEPARTMENT_MAPPING_WRITE',
          'EVENT_DETAILS_WRITE',
          'HOLIDAY_DETAILS_WRITE',
          'HOLIDAY_IMPORTED_DATA_WRITE',
          'ACTIVITY_DETAILS_WRITE',
          'STAFF_DETAILS_WRITE',
          'ORGANISATION_DETAILS_WRITE',
          'LOCATION_DETAILS_WRITE',
          'INDICATOR_DETAILS_WRITE',
          'PROFILE_DETAILS_WRITE',
          'STAFF_ALLOCATION_READ',
          'LEAVE_DETAILS_READ',
          'STREAM_MANAGEMENT_READ',
          'STREAM_MANAGEMENT_WRITE',
          'POST_MANAGEMENT_WRITE'
        ],
      },
      {
        locationId: '14a10bcf-162f-4b3f-a833-3a14060edb22',
        locationName:'Wellness Hospital , Luzern',
        departmentIds: ['d14d99c0-1573-4863-93f7-f82cf2bda257'],
        active: true,
        features: [
          'PLANNING_SHEET_READ',
          'PLANNING_SHEET_WRITE',
          'DUTY_MANAGEMENT_WRITE',
          'DUTY_MANAGEMENT_READ',
          'DUTY_PLANNING_ACTIVATION_WRITE',
          'DUTY_DEPARTMENT_MAPPING_WRITE',
          'EVENT_DETAILS_WRITE',
          'HOLIDAY_DETAILS_WRITE',
          'HOLIDAY_IMPORTED_DATA_WRITE',
          'ACTIVITY_DETAILS_WRITE',
          'STAFF_DETAILS_WRITE',
          'ORGANISATION_DETAILS_WRITE',
          'LOCATION_DETAILS_WRITE',
          'INDICATOR_DETAILS_WRITE',
          'PROFILE_DETAILS_WRITE',
          'STAFF_ALLOCATION_READ',
          'LEAVE_DETAILS_READ',
          'STREAM_MANAGEMENT_READ',
          'STREAM_MANAGEMENT_WRITE',
          'POST_MANAGEMENT_WRITE'
        ],
      },
      {
        locationId: '607dcb44-0399-41f9-9020-9b533b175bd9',//updated university hospital id
        locationName:'University Hospital, Berne',
        departmentIds: ['d14d99c0-1573-4863-93f7-f82cf2bda257'],
        active: true,
        features: [
          'PLANNING_SHEET_READ',
          'PLANNING_SHEET_WRITE',
          'DUTY_MANAGEMENT_WRITE',
          'DUTY_MANAGEMENT_READ',
          'DUTY_PLANNING_ACTIVATION_WRITE',
          'DUTY_DEPARTMENT_MAPPING_WRITE',
          'EVENT_DETAILS_WRITE',
          'HOLIDAY_DETAILS_WRITE',
          'HOLIDAY_IMPORTED_DATA_WRITE',
          'ACTIVITY_DETAILS_WRITE',
          'STAFF_DETAILS_WRITE',
          'ORGANISATION_DETAILS_WRITE',
          'LOCATION_DETAILS_WRITE',
          'INDICATOR_DETAILS_WRITE',
          'PROFILE_DETAILS_WRITE',
          'STAFF_ALLOCATION_READ',
          'LEAVE_DETAILS_READ',
          'STREAM_MANAGEMENT_READ',
          'STREAM_MANAGEMENT_WRITE',
          'POST_MANAGEMENT_WRITE'
        ],
      },
      {
        locationId: 'fb92dbef-2f67-44ec-add2-26fa8a665b0c',
        locationName:"Canton Hospital, Berne",
        departmentIds: ['ddf8c9a4-ea91-4a4b-960f-41097c556e1b'],
        active: true,
        features: [
          'PLANNING_SHEET_READ',
          'PLANNING_SHEET_WRITE',
          'DUTY_MANAGEMENT_WRITE',
          'DUTY_MANAGEMENT_READ',
          'DUTY_PLANNING_ACTIVATION_WRITE',
          'DUTY_DEPARTMENT_MAPPING_WRITE',
          'EVENT_DETAILS_WRITE',
          'HOLIDAY_DETAILS_WRITE',
          'HOLIDAY_IMPORTED_DATA_WRITE',
          'ACTIVITY_DETAILS_WRITE',
          'STAFF_DETAILS_WRITE',
          'ORGANISATION_DETAILS_WRITE',
          'LOCATION_DETAILS_WRITE',
          'INDICATOR_DETAILS_WRITE',
          'PROFILE_DETAILS_WRITE',
          'STAFF_ALLOCATION_READ',
          'LEAVE_DETAILS_READ',
          'STREAM_MANAGEMENT_READ',
          'STREAM_MANAGEMENT_WRITE',
          'POST_MANAGEMENT_WRITE'
        ],
      },
      {
        locationId: '96c5af80-df2e-4155-8146-37bb9cf379ab',
        locationName:"BMH Calicut",
        departmentIds: ['ddf8c9a4-ea91-4a4b-960f-41097c556e1b'],
        active: true,
        features: [
          'PLANNING_SHEET_READ',
          'PLANNING_SHEET_WRITE',
          'DUTY_MANAGEMENT_WRITE',
          'DUTY_MANAGEMENT_READ',
          'DUTY_PLANNING_ACTIVATION_WRITE',
          'DUTY_DEPARTMENT_MAPPING_WRITE',
          'EVENT_DETAILS_WRITE',
          'HOLIDAY_DETAILS_WRITE',
          'HOLIDAY_IMPORTED_DATA_WRITE',
          'ACTIVITY_DETAILS_WRITE',
          'STAFF_DETAILS_WRITE',
          'ORGANISATION_DETAILS_WRITE',
          'LOCATION_DETAILS_WRITE',
          'INDICATOR_DETAILS_WRITE',
          'PROFILE_DETAILS_WRITE',
          'STAFF_ALLOCATION_READ',
          'LEAVE_DETAILS_READ'
        ],
      },
      {
        locationId: 'bfdb5f07-cfe5-40e8-beaa-2ce4b9a68446',
        locationName:"TIMS Kollam",        
        departmentIds: ['ddf8c9a4-ea91-4a4b-960f-41097c556e1b'],
        active: true,
        features: [
          'PLANNING_SHEET_READ',
          'PLANNING_SHEET_WRITE',
          'DUTY_MANAGEMENT_WRITE',
          'DUTY_MANAGEMENT_READ',
          'DUTY_PLANNING_ACTIVATION_WRITE',
          'DUTY_DEPARTMENT_MAPPING_WRITE',
          'EVENT_DETAILS_WRITE',
          'HOLIDAY_DETAILS_WRITE',
          'HOLIDAY_IMPORTED_DATA_WRITE',
          'ACTIVITY_DETAILS_WRITE',
          'STAFF_DETAILS_WRITE',
          'ORGANISATION_DETAILS_WRITE',
          'LOCATION_DETAILS_WRITE',
          'INDICATOR_DETAILS_WRITE',
          'PROFILE_DETAILS_WRITE',
          'STAFF_ALLOCATION_READ',
          'LEAVE_DETAILS_READ',
          'STREAM_MANAGEMENT_READ',
          'STREAM_MANAGEMENT_WRITE',
          'POST_MANAGEMENT_WRITE'
        ],
      },
      {
        locationId: '40ff7479-d9d1-44d2-93cd-d242303b6ad2',
        locationName:"TIMS Trivandrum",
        departmentIds: ['ddf8c9a4-ea91-4a4b-960f-41097c556e1b'],
        active: true,
        features: [
          'PLANNING_SHEET_READ',
          'PLANNING_SHEET_WRITE',
          'DUTY_MANAGEMENT_WRITE',
          'DUTY_MANAGEMENT_READ',
          'DUTY_PLANNING_ACTIVATION_WRITE',
          'DUTY_DEPARTMENT_MAPPING_WRITE',
          'EVENT_DETAILS_WRITE',
          'HOLIDAY_DETAILS_WRITE',
          'HOLIDAY_IMPORTED_DATA_WRITE',
          'ACTIVITY_DETAILS_WRITE',
          'STAFF_DETAILS_WRITE',
          'ORGANISATION_DETAILS_WRITE',
          'LOCATION_DETAILS_WRITE',
          'INDICATOR_DETAILS_WRITE',
          'PROFILE_DETAILS_WRITE',
          'STAFF_ALLOCATION_READ',
          'LEAVE_DETAILS_READ'
        ],
      },
    ],
    isActive: false,
  },
  {
    roleName: 'STAFF',
    locations: [
      {
        locationId: '6e394600-45d8-4109-962f-c47f6e89421a',
        locationName:'Ascander Faruna',
        departmentIds: [
          'ddf8c9a4-ea91-4a4b-960f-41097c556e1b',
          'fcd6e4f5-e33f-41a2-b711-33bfc2390022',
        ],
        active: true,
        features: [
          'PLANNING_SHEET_READ',
          'PLANNING_SHEET_WRITE',
          'DUTY_MANAGEMENT_WRITE',
        ],
      },
    ],
    isActive: true,
  },
  {
    roleName: 'DEP_ADMIN',
    locations: [
      {
        locationId: '96c5af80-df2e-4155-8146-37bb9cf379ab',
        locationName:'BMH Calicut',
        departmentIds: ['fcd6e4f5-e33f-41a2-b711-33bfc2390022'],
        active: true,
        features: [
          'DUTY_PLANNING_ACTIVATION_WRITE',
          'DUTY_DEPARTMENT_MAPPING_WRITE',
        ],
      },
    ],
    isActive: true,
  },
];
// Key for storing data in local storage
export const LOCAL_STORAGE_KEYS = {
  USER_ROLE: 'userRole',
  ROLES_PERMISSIONS: 'rolesPermissions',
};
